@if (imageData && imageReady) {
  <div>
    <img alt="" class="mat-elevation-z8" [src]="imageData.thumbUrl" [width]="imageData.thumbWidth" [height]="imageData.thumbHeight">
  </div>
} @else {
  <pub-no-image></pub-no-image>
}

